import React from "react"

import classNames from "classnames"

export interface LoadingSpinnerProps {
  small?: boolean
  className?: string
  "aria-label"?: string
  "aria-hidden"?: boolean
}

const style = { fontSize: "initial" }

export const LoadingSpinner = React.memo(
  ({
    small,
    "aria-label": ariaLabel,
    "aria-hidden": ariaHidden,
    className
  }: LoadingSpinnerProps) => (
    <div
      className={classNames(
        "spinner-border",
        small ? "spinner-border-sm" : undefined,
        "flex-grow-0",
        "flex-shrink-0",
        className
      )}
      style={style}
      role="status"
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
      data-testid="loading-spinner"
    />
  )
)
